module.exports = __webpack_public_path__ + "img/mascote-2.15113599.svg";